import classNames from 'classnames'
import { useFormikContext } from 'formik'

import type { ReactElement } from 'react'
import type { IPageContainerFormValues, ITemplateProps } from '~/types/template'

import { getChildren, getProps } from '../../utils'

import './styles.scss'

interface Props {
  className?: string
}

const BaseTemplate = ({ className, onBlockClick, pageIndex, templateConfig }: ITemplateProps & Props): ReactElement => {
  const { values } = useFormikContext<IPageContainerFormValues>()

  const classes = classNames('base-template', className, templateConfig[pageIndex].className)

  const currentPage = templateConfig[pageIndex]

  const { backgroundImage, blocks } = currentPage

  const page = (): ReactElement => {
    const children = getChildren({
      currentPage,
      exclude: backgroundImage,
      onClick: onBlockClick,
      values,
    })

    const content = (
      <>
        {blocks}
        {children}
      </>
    )

    if (backgroundImage) {
      const backgroundImageComponent = currentPage.placeholders.find(
        ({ placeholderKey }) => placeholderKey === backgroundImage
      )

      const backgroundImageProps = getProps(backgroundImage, values)

      return backgroundImageComponent ? (
        <backgroundImageComponent.component {...backgroundImageProps}>{content}</backgroundImageComponent.component>
      ) : (
        content
      )
    }

    return content
  }

  return (
    <div className={classes} id="renderer-node">
      {page()}
    </div>
  )
}

export default BaseTemplate
